import script from "./PresetApplier.vue?vue&type=script&setup=true&lang=js"
export * from "./PresetApplier.vue?vue&type=script&setup=true&lang=js"

import "./PresetApplier.vue?vue&type=style&index=0&id=62b01e94&scoped=true&lang=css"

import exportComponent from "/home/dragos/Work/cozmoslabs-ddev/translatepress/wp-content/plugins/translatepress/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62b01e94"]])

export default __exports__